export default class Sql {
  constructor(IdSql, Descricao, Status, InstrucaoSql, Configuracoes) {
    this.IdSql = IdSql || null;
    this.Descricao = Descricao;
    this.Status = Status || 'A';
    this.InstrucaoSql = InstrucaoSql;
    this.Configuracoes = Configuracoes || null;
  }
}